import React, { Suspense, useRef, useState, useEffect, useMemo } from 'react'
import './App.css';
import * as THREE from 'three';
import { Stats, Html, Center, OrbitControls, MeshDistortMaterial, BakeShadows } from '@react-three/drei';
import { Canvas, extend, useThree, useFrame } from '@react-three/fiber'
import { useLoader } from '@react-three/fiber'
import { useTexture } from '@react-three/drei';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { Physics, useSphere, usePlane, useCylinder, useBox } from "@react-three/cannon"

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { SSAOPass } from 'three/examples/jsm/postprocessing/SSAOPass'
import { BokehPass } from 'three/examples/jsm/postprocessing/BokehPass'
import { TextureLoader } from 'three/src/loaders/TextureLoader.js';
import { MeshBasicMaterial } from 'three';
import { MeshStandardMaterial } from 'three';
import { Vector3 } from 'three';
import { Color } from 'three';
import { Group } from 'three';
import { genererFigures } from "./figures";

extend({ EffectComposer, RenderPass, UnrealBloomPass, SSAOPass, BokehPass });


function Effect({ down }) {
  const composer = useRef()
  const { scene, gl, size, camera } = useThree()
  const aspect = useMemo(() => new THREE.Vector2(size.width, size.height), [size])
  const params = useMemo(() => ({ focus: 0, aperture: 0.05, maxblur: 0.018 }), [])
  useEffect(() => void composer.current.setSize(size.width, size.height), [size])
  useFrame(() => composer.current.render(), 1)
  return (
    <>
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" scene={scene} camera={camera} />
      {/* <sSAOPass attachArray="passes" args={[scene, camera, 1024, 1024]} kernelRadius={5.8} maxDistance={5.4} /> */}
      <unrealBloomPass attachArray="passes" args={[aspect, 1.5, 0.5, 0]} />
      {/* <bokehPass attachArray="passes" args={[scene, camera, params]} /> */}
    </effectComposer>
    </>
  )
}


function Trails() {
  
    const { scene, camera, gl } = useThree();
    camera.near = 0.01;
    camera.updateProjectionMatrix();

    var fadeMaterial = new THREE.MeshBasicMaterial({
        color: 0x000000,
        transparent: true,
        opacity: 0.1
    });
    var fadePlane = new THREE.PlaneBufferGeometry(100, 100);
    var fadeMesh = new THREE.Mesh(fadePlane, fadeMaterial);

    if(camera.children.length === 0) {
        camera.add(fadeMesh);
        scene.add(camera);
        
    }

    fadeMesh.position.set(0,0,-1);
    fadeMesh.rotation.set(0, 0, Math.PI / 2)

    fadeMesh.renderOrder = 1;

    useFrame(() => {
      gl.autoClearColor = !holding;
    })
  return null;
}



function getCanvasTexture(color) {

  const canvas = document.createElement('canvas');
  canvas.width = 1024;
  canvas.height = 1024;
  const context = canvas.getContext('2d');

  context.fillStyle = '#000000';
  context.fillRect(0,0, 1024, 1024);
  context.lineWidth     = 20;
  context.shadowOffsetX = 5;
  context.shadowOffsetY = 5;
  context.shadowBlur    = 10;
  context.shadowColor   = "black";

  for(let i=0; i < 100; i++) {
    context.strokeStyle = 'hsl(0,0%,' +  window.fxrand() * 50 + '%)';
    drawLine(context, 0, window.fxrand() * 1024, 1024);
  }

  return canvas;
}

function getCanvasTexture2(color) {

  const canvas = document.createElement('canvas');
  canvas.width = 256;
  canvas.height = 256;
  const context = canvas.getContext('2d');

  context.fillStyle = '#000000';
  context.fillRect(0,0, 256, 256);
  context.lineWidth     = 20;
  context.shadowOffsetX = 5;
  context.shadowOffsetY = 5;
  context.shadowBlur    = 10;
  context.shadowColor   = "black";

  for(let i=0; i < 5; i++) {
    context.strokeStyle = 'hsl(0,0%,' +  window.fxrand() * 100 + '%)';
    // drawLine(context, 0, window.fxrand() * 256, 256);
    
    context.beginPath();
    let start = window.fxrand() * 256;
    context.moveTo(start, 0);
    context.lineTo(window.fxrand() * 256, 256 / 2);
    context.lineTo(start, 256 + 10);
    context.stroke();
  }

  return canvas;
}

function drawLine(context, xStart, yStart, size)
{

  context.beginPath();
  context.moveTo(xStart - 10, yStart);
  context.lineTo(size / 2, window.fxrand() * size);
  context.lineTo(size + 10, yStart);
  context.stroke();
}

let posY = 0;

function Handle() {
  let ref = useRef();
  const canvas = getCanvasTexture('#ff0000');
  const texture = new THREE.CanvasTexture(canvas);
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;

  useEffect(() => {
    const points = [];
    points.push( new THREE.Vector2( 0, 0 ) );
    let startY = 0;
    for ( let i = 0; i < window.fxrand() * 5 + 4; i ++ ) {
      points.push( new THREE.Vector2( window.fxrand() * 3 + 1, startY ) );
      startY += window.fxrand() * 2 + 1;
    }
    points.push( new THREE.Vector2( 2, startY ) );
    points.push( new THREE.Vector2( 0, startY ) );

    const geometry = new THREE.LatheGeometry( points );

    const material = new THREE.MeshPhysicalMaterial( { map: texture } );
    const handle = new THREE.Mesh( geometry, material );
    handle.rotation.set(0,Math.PI,0);
    ref.current?.add( handle );

    const shape = new THREE.Shape();
    shape.moveTo( 0,0 );
    let p = [[0,0]];
    for(let i = 0; i < 4; i++) {
      p[i+1] = [p[i][0] + 5, p[i][1] - (window.fxrand() - 0.5) * 5];
      shape.lineTo( p[i+1][0], p[i+1][1] );
    }
    for(let i = 3; i >= 0; i--) {
      if(p[i][1] < 0)
        shape.lineTo( p[i][0], -p[i][1] );
      else
        shape.lineTo( p[i][0], p[i][1] + window.fxrand() * 2 );
    }
    shape.lineTo( 0, 0 );

    const extrudeSettings = {
      steps: 2,
      depth: 0,
      bevelEnabled: true,
      bevelThickness: 0.8,
      bevelSize: 1,
      bevelOffset: 0,
      bevelSegments: 1
    };

    const geometryTop = new THREE.ExtrudeGeometry( shape, extrudeSettings );
    const materialTop = new THREE.MeshStandardMaterial( { side: THREE.DoubleSide, map: texture } );
    const mesh = new THREE.Mesh( geometryTop, materialTop );
    mesh.position.set(0, startY, 0);
    const symmetry = mesh.clone();
    symmetry.rotateY(Math.PI);
    symmetry.position.z += 0.002;
    ref.current?.add(mesh);
    ref.current?.add(symmetry);

    posY = startY + Math.abs(p[3][1]);
  },[ref]);
  
  // useFrame(({clock}) => {

  //   // console.log(clock.elapsedTime);
  //   let t = clock.elapsedTime * 10;
  //   if(t < 10) {
  //     // ctx.rotate(window.fxrand() / 10);
  //     ctx.fillStyle = 'hsl('+ 60*window.fxrand() +',100%,' + window.fxrand() * 50 + 20 + '%)';
  //     drawLine(ctx, 0, window.fxrand() * 256, 256, window.fxrand() * 256);
  //     // ctx.fillRect(0,i, 256, 5);
  //     texture.needsUpdate = true;
  //   }

  // })

  return <group ref={ref} name='handle'></group>
}

function Head() {
  
  let ref = useRef();
  const canvas = getCanvasTexture2('#ff0000');
  const texture = new THREE.CanvasTexture(canvas);
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(0.1,0.1);

  useEffect(() => {

    const shape = new THREE.Shape();
    shape.moveTo( 0,0 );
    let p = [[0,0]];
    for(let i = 0; i < 20; i++) {
      // if(window.fxrand() > 0.5)
      // let spike = (window.fxrand() - 0.5) * 5;
      //   p[i+1] = [p[i][0] + spike, p[i][1] + 0.2 + window.fxrand() * 5];
      // else
        p[i+1] = [(window.fxrand() - 0.5) * 10, p[i][1] + 0.2 + window.fxrand() * 5];
      shape.lineTo( p[i+1][0], p[i+1][1] );
    }
    
    for(let i = 19; i >= 0 ; i--) {
      shape.lineTo( p[i][0] + window.fxrand() * 10, p[i][1] );
    }
    shape.lineTo( 0, 0 );

    const extrudeSettings = {
      steps: 2,
      depth: 0,
      bevelEnabled: true,
      bevelThickness: 1,
      bevelSize: 2,
      bevelOffset: 0,
      bevelSegments: 1
    };

    const geometryTop = new THREE.ExtrudeGeometry( shape, extrudeSettings );
    const materialTop = new THREE.MeshStandardMaterial( { side: THREE.DoubleSide, map: texture } );
    const mesh = new THREE.Mesh( geometryTop, materialTop );
    mesh.position.set(1.2, 0, 0);
    const symmetry = mesh.clone();
    mesh.position.set(-1.2, 0, 0.1);
    symmetry.rotateY(Math.PI);
    ref.current?.add(mesh);
    ref.current?.add(symmetry);
  },[ref]);
  
  useFrame(({clock}) => {
    ref.current?.position.set(0, posY, 0);
    texture.offset.set(0, clock.getElapsedTime() / 3);
  })

  return <group ref={ref} name='head'></group>
}

let holding = false;
function CameraControls() {
  const { scene, camera, gl, raycaster } = useThree();
  let transition = 0, delta = 0, lastTime = 0;
  let lastHolding = false;
  // const ref=useRef();

  camera.position.set(0, 50, 70);
  camera.lookAt(0,50,0);

  useFrame(({clock, mouse}) => {
    delta = clock.elapsedTime - lastTime;

    if(holding) {
      if(!lastHolding) {
        transition = 0;
        lastHolding = true;
      }

      camera.position.lerp(new THREE.Vector3(0, 50, 70), transition);
      // camera.position.set(0, 50, 70);
      camera.lookAt(0,40,0);
      
      if(transition < 1)
        transition += delta / 10;
      else transition = 1;
    }
    else {
      if(lastHolding) {
        transition = 0;
        lastHolding = false;
      }

      camera.position.lerp(new THREE.Vector3(Math.sin(-mouse.x) * 50, 50, Math.cos(-mouse.x) * 50), transition);
      camera.lookAt(0,40,0);

      
      if(transition < 1)
        transition += delta / 10;
      else transition = 1;
    }

    lastTime = clock.elapsedTime;
  })

  return null;
}



function MyBox({...props}) {
  const [ref, api] = useBox(() => ({ mass: 3, ...props, args:[20,20,20] }));
  const pos = useRef([0, 0, 0])
  useEffect(() => api.position.subscribe(v => pos.current = v), [])

  useFrame(() => {
    ref.current.visible = holding;
    if(pos.current[1] < 0 || pos.current[1] > 200 || pos.current[0] < -100 || pos.current[0] > 100)  {
      api.position.set(Math.random(), 50, -40);
      api.velocity.set(0,5,0)
    }
  })

  return (
    <mesh ref={ref} {...props}>
      <boxGeometry args={[20,20,20]} />
      <meshStandardMaterial attach="material" color={'grey'}/>
    </mesh>
  )
}

function Sword(props) {
  const [ref, api] = useCylinder(() => ({ ...props, args: [10, 10, 1000, 20] }));
  let transition = 0, delta = 0, lastTime = 0;
  let lastHolding = false;
  let geomArray = props.swordGeometries.figures;
  console.log(props);

  useEffect(() => {

    const canvas = getCanvasTexture2('#ff0000');
    const texture = new THREE.CanvasTexture(canvas);
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.repeat.set(0.1,0.1);

    
    
    const canvas2 = getCanvasTexture('#ff0000');
    const texture2 = new THREE.CanvasTexture(canvas2);
    texture2.wrapS = THREE.RepeatWrapping;
    texture2.wrapT = THREE.RepeatWrapping;


    geomArray.forEach(({geometry, rot, pos}, i)=>{
      console.log(geometry);
      if (geometry.type==="ExtrudeGeometry"){
      
       var shape = new THREE.Shape();
       geometry.shapeArgs.forEach((d) => shape[d.draw](...d.drawArgs));
      

      const geometryTop = new THREE.ExtrudeGeometry(shape, geometry.extrudeSettings);
      const materialTop = new THREE.MeshStandardMaterial( { side: THREE.DoubleSide, map: texture } );
      const mesh = new THREE.Mesh( geometryTop, materialTop );
      mesh.rotation.set(rot.x, rot.y, rot.z);
      mesh.position.set(pos.x/3, -pos.y, pos.z);
      ref.current.add(mesh);
      
      //add the rest of your extrude geometry code here
      
      
      } else {
      
      let geo = new THREE[geometry.type](...geometry.args)
      
      const material = new THREE.MeshPhysicalMaterial( { map: texture2 } );
      const handle = new THREE.Mesh( geo, material );
      handle.rotation.set(rot.x, rot.y, rot.z);
      handle.position.set(pos.x, pos.y+40, pos.z);
      ref.current.add( handle );
      // handle part here
      }
  })}
  )

  useFrame(({clock, raycaster, mouse, camera, scene}) => {
    delta = clock.elapsedTime - lastTime;

    if(holding) {
      if(!lastHolding) {
        transition = 0;
        lastHolding = true;
      }
      
      raycaster.setFromCamera(mouse, camera);

      const intersects = raycaster.intersectObjects([scene.getObjectByName('plane')], true );
      // scene.getObjectByName('plane').lookAt(camera.position);
      if(intersects.length > 0)
      {
        api.position.copy(intersects[0].point);
        api.rotation.set(-Math.PI / 3, -mouse.x, 0);
        // api.lookAt(new THREE.Vector3(0,50,0));
        // api.rotateX(Math.PI / 3);
        // api.rotateY(Math.PI / 2);
      }
      
      if(transition < 1)
        transition += delta / 10;
      else transition = 1;
    }
    else {
      if(lastHolding) {
        transition = 0;
        lastHolding = false;
      }

      api.position.set(0,0,0);
      api.rotation.set(0,0,0);

      
      if(transition < 1)
        transition += delta / 10;
      else transition = 1;
    }

    lastTime = clock.elapsedTime;
  })

  return (
    <group name='sword' ref={ref}>
      {/* <Handle />
      <Head /> */}
    </group>
  )
}

function Background() {
  const texture = useLoader(THREE.TextureLoader, 'background2.png');
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;

  useFrame(({clock}) => {
    texture.offset.set(0, -clock.elapsedTime / 10)
  })

  return (
    <mesh position={[0,0,-10]}>
      <icosahedronGeometry args={[200, 0]} />
      <meshStandardMaterial map={texture} side={THREE.DoubleSide} color={0x101010} flatShading={true}/>
    </mesh>
  );
}


function App() {
  const [id, setId] = useState(0);
  const [characters, set] = useState([]);
  
  console.log(window.fxhash);
  const swordGeometries = genererFigures(window.fxhash); 
  const nextRand = window.fxrand() * 356;
  useEffect(() => {
    // doFetch(objkt)
    //   .then((data) => changeData(data, id))
    //   .then((char) => set(char));
  }, [id])


  return (
    <div id="wrapper" onMouseDown={() => {holding = true}} onMouseUp={() => {holding=false}}>
  <Canvas>
    
    <Effect />
      <pointLight position={[0,600,100]} intensity={8.0} color={'hsl(' + nextRand + ',100%, 50%)'} />
      <pointLight position={[0,-600,-100]} intensity={8.0} color={'hsl(' + nextRand + ',100%, 50%)'} />
      <CameraControls />
      
      <Physics>
        <Suspense fallback={null}>
          <Sword swordGeometries={swordGeometries}/>
          <MyBox  position={[0, 100, -40]} />
          <Background />
        </Suspense>
      </Physics>
      
      
      <mesh position={[0,0,10]} name={'plane'}>
        <planeGeometry args={[1000, 1000]} />
        <meshBasicMaterial color="black" visible={false}/>
      </mesh>


    {/* <OrbitControls />  */}
    <Trails />
    {/* <Stats /> */}
  </Canvas>
  </div>
  );
}

export default App;
